<script setup>
import { onMounted, onUnmounted, ref } from "vue";
import { useWebRTCStore } from "@/stores/webrtc";
import { useRoute } from "vue-router";

const route = useRoute();

const playClicked = ref(false);
const playing = ref(false);

const audioWss = import.meta.env.VITE_AUDIO_WSS;

const webrtc = useWebRTCStore();

onMounted(() => {
  webrtc.initialize(audioWss);
});

function play() {
  playClicked.value = true;
  const roomId = route.query.roomId || "774717741986";
  useWebRTCStore().playStreamByRoomId(parseInt(roomId));
}

function stop() {
  useWebRTCStore().stopStream();
}

function toggle() {
  if (playing.value) {
    stop();
    playClicked.value = false;
  } else {
    play();
  }
  setTimeout(() => {
    checkIfPaused();
  }, 100);
}

const checkInterval = ref(0);
function checkIfPaused() {
  const audio = document.getElementById("remoteAudio");
  playing.value = !audio.paused;
  if (playing.value) playClicked.value = false;
}

onMounted(() => {
  checkInterval.value = setInterval(checkIfPaused, 1000);
});

onUnmounted(() => {
  clearInterval(checkInterval.value);
});
</script>

<template>
  <div
    class="flex flex-col w-full h-full p-6 justify-between font-futura-heavy text-[#D7FF47] overflow-y-auto"
    :style="{
      background: `linear-gradient(rgba(0,0,0,0.3), rgba(0,0,0,0.3)), url('/images/background_low.jpg') no-repeat center center fixed`,
      'background-size': 'cover',
    }"
  >
    <audio id="remoteAudio" title="Soonia" class="hidden" controls=""></audio>
    <img src="/images/logo.svg" alt="logo" class="w-[14.5rem]" />
    <div class="gap-[50px] w-full flex flex-col">
      <div class="uppercase text-center leading-none">
        <p class="text-[49px] text-white">Led by Locals</p>
        <p class="text-[31px]">Napoli</p>
      </div>
      <div class="text-center leading-none">
        <p class="text-[25px]">Led by THANKSMATE</p>
        <p class="text-[25px]">Now Live from: Lento Hi-Fi</p>
      </div>
    </div>
    <div class="flex flex-col gap-4">
      <button
        class="bg-[#D7FF47] py-[22px] w-[13.75rem] rounded-[90px] place-self-center uppercase flex flex-row gap-5 items-center justify-center text-black"
        @click="toggle"
      >
        <img
          :src="!playing ? '/images/play.svg' : '/images/pause.svg'"
          :alt="!playing ? 'play icon' : 'pause icon'"
          class="w-8"
        />
        <span class="text-[19px]">
          {{ !playing ? "Play audio" : "Pause audio" }}
        </span>
      </button>
      <div class="flex flex-row gap-[10px] justify-center items-center" v-if="playing">
        <img src="/images/streaming-live.svg" alt="streaming live" class="w-2 animate-pulse" />
        <p class="uppercase text-white text-[13px]">Streaming live</p>
      </div>
      <div class="flex flex-row gap-[10px] justify-center items-center" v-else-if="playClicked">
        <img src="/images/streaming-live.svg" alt="connecting" class="w-2 animate-pulse" />
        <p class="uppercase text-white text-[13px]">Connecting...</p>
      </div>
    </div>
    <img src="/images/hoka.svg" alt="logo" class="w-[7.5rem]" />
  </div>
</template>
